/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerskindorganisation2Inputs */

const en_partnerskindorganisation2 = /** @type {(inputs: Partnerskindorganisation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

const de_partnerskindorganisation2 = /** @type {(inputs: Partnerskindorganisation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "Organisation" |
*
* @param {Partnerskindorganisation2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerskindorganisation2 = /** @type {((inputs?: Partnerskindorganisation2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerskindorganisation2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerskindorganisation2(inputs)
	return de_partnerskindorganisation2(inputs)
});
export { partnerskindorganisation2 as "partnersKindOrganisation" }